// Escape user input before interpolating into a PostgREST .ilike() or .or() filter.
// % and _ are PostgREST wildcards; ( ) , \ can break filter-string syntax.
export function escapeIlike(str) {
  if (!str) return '';
  return str
    .replace(/[(),\\]/g, '')   // strip chars that break filter syntax
    .replace(/%/g, '\\%')      // escape wildcard %
    .replace(/_/g, '\\_');     // escape single-char wildcard _
}
